import React, { FC } from "react";
import { Box } from "../../../../../components/box";
import CommentSection from "../../../info-technology-process/commentsection/comment-sections";
import { getHHmmFormat } from "../../../../../helper/dateTimeHelper";
import { getDDMMYYYFormat } from "../../../../../helper/dateTimeHelper";
import { Form, Input } from "antd";
import { StyledTitle } from "../../../../../components/styled-antd/Title";

import { getApproverName, getEmployeeDetail } from "../../../human-organization/summary-employee-request/utils/get-employee-detail";
import { useSelector } from "../../../../../store/store";
import { useSoftwares } from "../../../../../hook";
import { SystemCode } from "../../../../../constants";
import { RenderApprovalHistory } from "../../../human-organization/summary-employee-request/utils/render-helper";

export const RecallToolHistory: FC<{
  detail: any;
  employees: any;
  form: any;
  isEnableAccept: boolean;
}> = ({ detail, employees, form, isEnableAccept }) => {
  const user = useSelector((state) => state.user);
  const { getITLeadITHeadAssignee } = useSoftwares();
  const softwares = useSelector((state: any) => state.systemMgmt.softwares);

  const history = [
    {
      status: detail?.fields?.eApprovedStatus,
      name:
        detail?.fields?.eApprovedName ||
        getEmployeeDetail(
          detail?.fields?.eApprovedBy?.toLowerCase(),
          employees,
          softwares
        )?.[0]?.Title,
      approvedDate: detail?.fields?.eApprovedDate,
      title: "Thủ trưởng cơ quan đơn vị",
      comment: detail.fields?.eApprovalComment,
    },
    {
      status: detail?.fields?.eApprovedByITLeadStatus,
      // name: getITLeadITHeadAssignee(SystemCode.ETR)?.eApprovedByITLead?.split(
      //   "|"
      // )[1],
      name: getApproverName(
        detail?.fields?.eApprovedByITLead,
        employees,
        softwares,
        getITLeadITHeadAssignee(SystemCode.ETR).eApprovedByITLead
      ),
      approvedDate: detail?.fields?.eApprovedByITLeadDate,
      title: "Bộ phận kỹ thuật",
      comment: detail.fields?.eITLeadComment,
    },

    {
      status: detail?.fields?.eApprovedByITHeadStatus,
      // name: getITLeadITHeadAssignee(SystemCode.ETR)?.eApprovedByITHead?.split(
      //   "|"
      // )?.[1],
      name: getApproverName(
        detail?.fields?.eApprovedByITHead,
        employees,
        softwares,
        getITLeadITHeadAssignee(SystemCode.ETR).eApprovedByITHead
      ),
      approvedDate: detail?.fields?.eApprovedByITHeadDate,
      title: "Bộ phận hành chính phòng KHĐT",
      comment: detail.fields?.eITHeadComment,
    },

    {
      status: detail?.fields?.eAssigneeStatus,
      //name: getITLeadITHeadAssignee(SystemCode.ETR)?.eAssignee?.split("|")[1],
      name: getApproverName(
        detail?.fields?.eAssignee,
        employees,
        softwares,
        getITLeadITHeadAssignee(SystemCode.ETR).eAssignee
      ),
      approvedDate: detail?.fields?.eAssigneeStatusDate,
      title: "Phòng KHĐT",
      comment: detail.fields?.eAssigneeComment,
    },
  ];  

  return (
    <>
      <Box title="Lịch sử phê duyệt">
        <div className="py-2 pl-3">
          <p>
            <span className="font-weight-bold">
              {detail?.createdBy?.user?.displayName}
            </span>{" "}
            đã tạo lúc {getDDMMYYYFormat(detail?.createdDateTime)} -{" "}
            {getHHmmFormat(detail?.createdDateTime)}
          </p>
        </div>

        <RenderApprovalHistory history={history} />

        <Form form={form}>
          <Form.Item name="comment">
            <StyledTitle level={5}>Comments</StyledTitle>
            <Input.TextArea
              onChange={(e) => {
                form.setFieldsValue({
                  comment: e.target.value,
                });
              }}
              disabled={!isEnableAccept}
            />
          </Form.Item>
        </Form>
      </Box>

      <Box title="Thông tin trao đổi">
        <CommentSection
          comments={[]}
          data={detail}
          user={user}
          id={11}
          className="mb-4"
        />
      </Box>
    </>
  );
};
